export const ROLE_INITIAL_FILTER_FIELDS = ['name', 'category', 'status']
